import React, { ReactNode, ComponentProps, CSSProperties } from 'react';

import { Box } from '@adsk/alloy-react-box';
import { SideNavigationProvider } from '@adsk/alloy-side-navigation';
import TopNavigation from '@adsk/alloy-top-navigation';

type TopNavigationProps = ComponentProps<typeof TopNavigation>;

type TopNavigationLayoutProps = {
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
  renderTopNavigation?: (props?: TopNavigationProps) => React.ReactNode;
  renderAboveLayout?: () => React.ReactNode;
};

/**
 * Skeleton for top navigation frame
 */
const TopNavigationLayout = React.forwardRef<
  HTMLDivElement,
  TopNavigationLayoutProps
>(
  (
    {
      children,
      renderTopNavigation = (props?: TopNavigationProps) => (
        <TopNavigation {...props} />
      ),
      renderAboveLayout,
      style,
      ...props
    },
    ref,
  ) => {
    return (
      <SideNavigationProvider>
        <Box
          display="flex"
          flexDirection="column"
          height="100vh"
          width="100vw"
          {...props}
          ref={ref}
          style={style}
        >
          {renderAboveLayout?.()}
          {renderTopNavigation()}
          <Box flex={1} minHeight={0} overflow="auto">
            {children}
          </Box>
        </Box>
      </SideNavigationProvider>
    );
  },
);

TopNavigationLayout.displayName = 'TopNavigationLayout';

export default TopNavigationLayout;
